import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { baseStyleSheet } from '../../styles/styles';
import { Modal } from '../Modal';
import { WarningIcon } from '../svgs/icons/WarningIcon';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	isOpen: boolean;
	onClose(shouldDelete?: boolean): void;
	styles?: StyleDeclarationValue[];
	userName?: string;
}

export const DeleteUserModal: React.FC<IProps> = observer(props => {
	const { className, isOpen, styles = [], onClose, userName } = props;

	const onDelete = () => {
		onClose(true);
	};

	const onCancel = () => {
		onClose(false);
	};

	return (
		<Modal
			className={`${css(styleSheet.container, ...styles)} delete-user-modal ${className || ''}`}
			isOpen={isOpen}
			onRequestClose={onClose}
			useDefaultHeader={true}
		>
			<div className={css(styleSheet.content)}>
				<WarningIcon />
				<div className={css(styleSheet.title)}>Delete User</div>
				<div className={css(styleSheet.warningText)}>
					Are you sure you want to delete {userName ? <strong>{userName}</strong> : 'this user'}? This action cannot be
					undone.
				</div>
				<div className={css(styleSheet.buttonContainer)}>
					<button className={css(styleSheet.button, baseStyleSheet.ctaButtonDestructiveSolid)} onClick={onDelete}>
						<span>Delete</span>
					</button>
					<button className={css(styleSheet.button, baseStyleSheet.ctaButtonReverse)} onClick={onCancel}>
						<span>Cancel</span>
					</button>
				</div>
			</div>
		</Modal>
	);
});
